module.exports = __webpack_public_path__ + "VIPM5.png?436e06f64d492bf35959b8cf3f4fec96";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/motorracing/VIPM5.png
// module id = 150
// module chunks = 0